export default [
  {
    path: '/visitor-management',
    name: 'visitor-management',
    component: () => import('@/views/visitors/VisitorSearch.vue'),
    meta: {
      protected: true,
      pageTitle: 'Visitor Management',
    },
  },
  {
    path: '/visitor-profile/:id',
    name: 'visitor-profile',
    component: () => import('@/views/visitors/VisitorProfile.vue'),
    meta: {
      protected: true,
      pageTitle: 'Visitor Profile',
    },
  },
  {
    path: '/visitors/create',
    name: 'create-visitor',
    component: () => import('@/views/visitors/CreateVisitor.vue'),
    meta: {
      protected: true,
      pageTitle: 'Create Visitor',
    },
  },
]
